import type { GenieKnowledgeEntry } from '../../types';

export const mononeuropathy: GenieKnowledgeEntry = {
  id: 'mononeuropathy',
  aliases: ['tarsal_tunnel_syndrome'],
  name: 'Mononeuropatía',
  category: 'neuropatico',
  conversation: {
    headline:
      'Lesión focal de un nervio periférico. EDX localiza el sitio, severidad y guía manejo conservador vs quirúrgico.',
    edxHighlights: [
      'Caída de amplitud/latencia en el segmento afectado',
      'Estudios segmentarios (inching) localizan compresión exacta',
      'EMG en músculos del nervio afectado: fibrilaciones + PUMs neurogénicos',
      'Clasificar: neuropraxia vs axonotmesis vs neurotmesis',
    ],
    pearls: [
      'Verificar temperatura antes de interpretar latencias en atrapamientos.',
      'Si múltiples mononeuropatías → buscar polineuropatía o vasculitis.',
    ],
    nextSteps: [
      'Estudios comparativos si el hallazgo es borderline',
      'Correlacionar con examen focal y posible causa (compresión, trauma)',
    ],
  },
  orientationHints: {
    temporalFit: ['acute', 'subacute', 'chronic'],
    whenToSuspect: 'Síntomas en territorio de un solo nervio periférico',
  },
};
